import axios from "axios";
import store from "../store";
import { errorHandler } from "@/utils/errorHandler";
import Cookies from "js-cookie";

const ROOT_API = process.env.ROOT_API;
const ACCESS_TOKEN_KEY = "access_token";
const USER_AGENT = navigator.userAgent;

function makeOfficeHeader() {
  return {
    "CLIENT-USER-AGENT": USER_AGENT,
    "Content-Type": "application/json",
    "ACCESS-TOKEN": getAccessToken() ?? ""
  };
}

export function getAccessToken() {
  const pkToken = localStorage.getItem("pk");
  if (pkToken) {
    return pkToken;
  } else {
    return (
      localStorage.getItem(ACCESS_TOKEN_KEY) ||
      $cookies.get(process.env.ACCESS_TOKEN_COOKIE) ||
      Cookies.get("user-token")
    );
  }
}

const showAlert = msg =>
  store.commit("SHOW_ALERT", {
    value: true,
    msg
  });

const showError = (status, response) => {
  if (status == 500)
    showAlert(`We're sorry, but something went wrong (${status})`);
  else if (status == 401 || status == 422) {
    if (response && response.config.url) {
      if (response.data && response.data.error)
        showAlert(`${response.data.error} (${status})`);
      else if (response.data && response.data.errors)
        showAlert(
          Array.isArray(response.data.errors)
            ? `${response.data.errors.join(",")}`
            : `${response.data.errors}`
        );
      else if (response?.data?.message) {
        showAlert(`${response?.data?.message}`);
      }
    }
  } else if (status == 404) {
    if (
      response.config.url.includes("profiles") &&
      response.config.method == "get"
    )
      return;

    showAlert(`The page you were looking for doesn't exist (${status})`);
  } else {
    showAlert(`We're sorry, but something went wrong`);
    errorHandler(response);
  }
};

const client = () => {
  const instance = axios.create({
    baseURL: ROOT_API,
    headers: makeOfficeHeader()
  });

  instance.interceptors.request.use(
    config => config,
    error => {
      console.log("errorr --- >> request ", error.response);

      if (error && error.response && error.response.status)
        showError(error?.response?.status, error?.response);

      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    response => response,
    error => {
      console.log("errorr --- >> ", error.response);

      if (error && error.response && error.response.status)
        showError(error?.response?.status, error?.response);

      return Promise.reject(error);
    }
  );

  return instance;
};

export default client;
export { client };



// WEBPACK FOOTER //
// ./src/utils/client.js